<template>
	<el-container id="main-container" :class="{'has-results': has_results}">
		<disclaimer v-if="needs_agreement"/>
		<template v-else>
			<el-aside :class="{'mobile-hidden': hide_form_mobile}">
				<search-form/>
				<el-button id="btnRefineSearch" @click="hide_form_mobile = false">Refine Search</el-button>
			</el-aside>
			<el-main>
				<template v-if="show_welcome_message">
					<div class="welcome-message">
						<h1>
							Welcome to the Ninth Circuit Solicitor's Office<br>
							Search Page for the State’s Bond Revocation &amp; Modification Motions
						</h1>
						<h1>Specify your search criteria in the shaded areas on the left side of this page.</h1>
						<h1>For a historical compilation of the State’s bond motions, click the button below.</h1>
						<el-button type="primary" @click="goToReport">Historical Bond Report</el-button>
					</div>
				</template>
				<template v-else>
					<bond-events-table v-if="has_results" :bond_events="bond_events"/>

					<!-- No result message here -->
					<div v-else class="welcome-message">
						<h1 style="color:#8b0000;">No results found!</h1>
						<h2 style="color:#8b0000;">Please refine your search criteria</h2>
					</div>

				</template>
			</el-main>
		</template>
	</el-container>
</template>

<script>
import searchForm from './components/Search-Form.vue';
import disclaimer from './components/Disclaimer';
import bondEventsTable from './components/Bond-Events-Table.vue';
import { mapFields } from 'vuex-map-fields';
import { mapState } from 'vuex';
export default {
	name: 'bond-events',
	components: {	disclaimer, searchForm, bondEventsTable },
	computed: {
		...mapState(['needs_agreement']),
		...mapFields(['bond_events', 'show_welcome_message', 'hide_form_mobile', 'report_url']),
		has_results(){
			return this.bond_events.length > 0;
		}
	},
	methods: {
		goToReport(){
			window.open(this.report_url);
		}
	}
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Lato|News+Cycle:400,700');

#btnRefineSearch{display:none;margin-right:0px;width:100%;}

.welcome-message{
	text-align:center;
}

.welcome-message .el-button{
	display: inline-block;
}

body{
	margin:0px;
}
.el-main{padding:0px;margin-left:1.5rem;overflow:hidden;}
aside{height:100%;margin:0 auto;}
.el-aside{overflow:inherit;} /* Gets rid of scroll bar in IE */
h1, h2, h3, h4, h5, p.secondary-detail{font-family:'News Cycle' !important;}
#main-container{
	all:initial;
	display:flex;
	max-width:1500px;
	width:95%;
	margin:20px auto;
	margin-top: 60px;
	font-family: 'Lato', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
@media (max-width:992px){
	#main-container.has-results aside.mobile-hidden #btnRefineSearch{
		display:block;
	}
	#main-container.has-results aside.mobile-hidden form.search-form{display:none;}
	#main-container{
		flex-direction:column;
		width:97%;
	}
	.el-main{margin-left:0;margin-top:2rem;}
}

.el-icon-plus{
	font-size:16px;
	font-weight:600;
}

.header-panel .header-column p{
	margin:0;
	color:#57565F;
	font-size:1rem;
}
@media (max-width:768px){
	.header-panel .header-column p{
		font-size:.75rem;
	}
}
.table-column{padding:15px;}
</style>
